import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import TopTenIntIndexOptionsFull from './top-ten-int-index-options-full';

const TopTenIntIndexOptionsFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <TopTenIntIndexOptionsFull {...props} />
    </QueryClientProvider>
  );
};

export { TopTenIntIndexOptionsFullWidget }
